import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import { ReactComponent as StyledRightArrowWhiteIcon } from '../../assets/img/go-arrow-white.svg';
import FootballBg from '../../assets/img/football-bg.png';

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledBrand = styled(Link)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
  color: ${({ theme }) => theme.headerText};
  min-width: 0;
  img {
    display: block;
    height: 26px;
    width: auto;
    max-width: min(240px, 42vw);
    object-fit: contain;
    flex-shrink: 0;
    filter: brightness(0) invert(1);
  }
`;

export const StyledMain = styled.section`
  position: relative;
  transition: margin-left 0.2s, margin-right 0.2s;
  padding: 16px;
  @media screen and (max-width: 1100px) {
    margin: 0 !important;
  }
`;

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0 16px 0 12px;
  height: ${({ theme }) => theme.headerHeight};
  min-height: ${({ theme }) => theme.headerHeight};
  background: ${({ theme }) => theme.header};
  color: ${({ theme }) => theme.headerText};
`;

export const StyledLeftHeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
`;
export const StyledRightHeaderSection = styled.div`
  font-family: Archivo;
  display: flex;
  flex-direction: row;
  align-items: center;
  p {
    font-size: 14px;
  }
`;

export const StyledCardWrapper = styled.div`
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 20px;
  row-gap: 40px;
  width: 100%;
  max-width: 1640px;
  box-sizing: border-box;
  margin: 0 auto 20px;
  padding: 0 50px;
  z-index: 0;
  @media only screen and (max-width: 1300px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media only screen and (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (max-width: 500px) {
    grid-template-columns: repeat(1, 1fr);
    column-gap: 0px;
    padding: 0 16px;
    margin-top: 20px;
  }
`;

export const StyledLeftWhiteArrow = styled(StyledRightArrowWhiteIcon)`
  width: 10px;
  height: 10px;
  margin-right: 10px;
  transform: rotate(-180deg);
`;

export const StyledBackButton = styled.span`
  font-family: 'Archivo', sans-serif;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  position: absolute;
  left: 65px;
  cursor: pointer;
`;

export const StyledTitle = styled.h2`
  color: #fff;
  font-size: 25px;
  line-height: 1.44;
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
  @media only screen and (max-width: 991px) {
    text-align: center;
    width: 100%;
    font-size: 18px;
  }
`;

export const StyledSubheader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  width: 100%;
  justify-content: center;
  margin-bottom: 30px;
`;

export const StyledWrapper = styled.main`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  z-index: 1;
  top: 0;
  left: 0;
  background-image: url(${FootballBg});
  background-color: ${({ theme }) => theme.header};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  > h1 {
    font-family: 'Archivo', sans-serif;
    font-style: normal;
    font-weight: 900;
    font-size: 28.833px;
    line-height: 41px;
    width: 100%;
    text-transform: none;
    margin-bottom: 24px;
    @media (min-width: 48em) {
      margin: 0 25px;
      margin-bottom: 24px;
    }
  }
  padding-top: calc(${({ theme }) => theme.headerHeight} + 34px);
  @media only screen and (max-width: 991px) {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: calc(${({ theme }) => theme.headerHeight} + 50px);
    width: 100%;
  }
`;

export const StyledMobileSubheader = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  width: 100%;
  top: ${({ theme }) => theme.headerHeight};
  z-index: 1;
  justify-content: space-between;
  margin-bottom: 30px;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.header};
`;

export const StyledMobileBackButton = styled.span`
  font-family: 'Archivo', sans-serif;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  position: relative;
`;
